// MSC MOD: Unminified and extended with start date support + slider notification
!function () {
  "use strict";

  customElements.get("countdown-timer") ||
    customElements.define(
      "countdown-timer",
      class extends HTMLElement {
        constructor() {
          super();
          this.daysInMs = 864e5;
          this.hoursInMs = this.daysInMs / 24;
          this.minutesInMs = this.hoursInMs / 60;
          this.secondsInMs = this.minutesInMs / 60;
          this.isLoading = true;
          this.isAnimated = false;
          this.update = this.update.bind(this);
        }

        connectedCallback() {
          this.section = this.closest("[data-section-type]");
          this.shopifySection = this.closest(".shopify-section");
          this.productTimer = this.closest("[data-product-timer]");
          this.expirationBehavior = this.getAttribute("data-expiration-behavior");
          this.leadingZero = this.hasAttribute("data-leading-zero");

          // MSC MOD START - start date countdown
          try {
            this.startDate = this.getAttribute('data-start-date');
            if (this.startDate !== null) {
              this.startDate = Date.parse(this.startDate);
            }
          } catch (e) {
            this.startDate = null;
          }
          this.sliderContainer = this.closest('[data-slider]');
          this.prevHidden = this.section ? this.section.classList.contains('countdown--hide') : false;
          // MSC MOD END

          this.shouldHideOnComplete = "hide" === this.expirationBehavior;
          this.shouldShowMessage = "show-message" === this.expirationBehavior;
          this.time = this.querySelector("time");
          this.endDate = Date.parse(this.time.dateTime);
          this.days = this.querySelector("[data-days]");
          this.hours = this.querySelector("[data-hours]");
          this.minutes = this.querySelector("[data-minutes]");
          this.seconds = this.querySelector("[data-seconds]");

          // MSC MOD START - in design mode always show all countdown slides for editing
          if (window.Shopify.designMode && this.section) {
            this.section.classList.remove('countdown--hide');
            if (this.prevHidden) {
              this.prevHidden = false;
              this.notifySlider();
            }
          }
          // MSC MOD END

          if (isNaN(this.endDate) || this.endDate <= Date.now()) {
            this.onComplete();
          } else {
            // MSC MOD START - countdown start/visibility (skipped in design mode)
            if (!window.Shopify.designMode) {
              if (this.startDate !== null && !isNaN(this.startDate)) {
                if (this.startDate > Date.now()) {
                  this.section.classList.add('countdown--hide');
                } else {
                  this.section.classList.remove('countdown--hide');
                }
              } else {
                this.section.classList.remove('countdown--hide');
              }
              const nowHiddenInit = this.section.classList.contains('countdown--hide');
              if (nowHiddenInit !== this.prevHidden) {
                this.prevHidden = nowHiddenInit;
                this.notifySlider();
              }
            }
            // MSC MOD END

            if (this.section.classList.contains("countdown")) {
              this.onLoad(true);
            }
            this.interval = setInterval(this.update, 1e3);
          }
        }

        disconnectedCallback() {
          this.stopTimer();
        }

        // MSC MOD START - notify slider of visibility change
        notifySlider() {
          if (this.sliderContainer) {
            this.sliderContainer.dispatchEvent(
              new CustomEvent('theme:countdown:visibility-changed', { bubbles: false })
            );
          }
        }
        // MSC MOD END

        stopTimer() {
          clearInterval(this.interval);
        }

        convertTime(t) {
          const s = this.formatDigits(parseInt(t / this.daysInMs, 10));
          t -= s * this.daysInMs;
          const e = this.formatDigits(parseInt(t / this.hoursInMs, 10));
          t -= e * this.hoursInMs;
          const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
          t -= i * this.minutesInMs;
          return { days: s, hours: e, minutes: i, seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)) };
        }

        formatDigits(t) {
          if (t < 10 && this.leadingZero) t = "0" + t;
          return t;
        }

        render(t) {
          this.days.textContent = t.days;
          this.hours.textContent = t.hours;
          this.minutes.textContent = t.minutes;
          this.seconds.textContent = t.seconds;
        }

        onComplete() {
          this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          if (this.shouldHideOnComplete && !window.Shopify.designMode) {
            // MSC MOD START - notify slider before removal so it can reload cells
            this.notifySlider();
            // MSC MOD END
            if (this.productTimer) {
              this.productTimer.remove();
            } else {
              this.shopifySection.remove();
            }
            document.dispatchEvent(new CustomEvent("theme:parallax:refresh"));
          }
          if (this.shouldShowMessage) {
            this.classList.add("countdown-timer--show-message");
          }
        }

        triggerAnimations() {
          if ("false" != theme.settings.animations) {
            this.section.querySelectorAll("[data-aos]").forEach((t) => {
              if (this.isAnimated) t.classList.add("aos-animate");
            });
          }
        }

        removeAnimations() {
          this.section.querySelectorAll("[data-aos]").forEach((t) => {
            requestAnimationFrame(() => {
              if (t.classList.contains("aos-animate")) {
                t.classList.remove("aos-animate");
                this.isAnimated = true;
              }
            });
          });
        }

        onLoad(t) {
          if (t) {
            this.removeAnimations();
          } else {
            this.isLoading = false;
            this.triggerAnimations();
          }
        }

        update() {
          const t = Date.now();
          const s = this.endDate - t;
          if (s <= 0) {
            this.stopTimer();
            this.onComplete();
            return;
          }

          // MSC MOD START - countdown start/visibility (update tick, skipped in design mode)
          if (!window.Shopify.designMode && this.startDate !== null && !isNaN(this.startDate)) {
            const shouldHide = this.startDate > Date.now();
            if (shouldHide !== this.prevHidden) {
              this.section.classList.toggle('countdown--hide', shouldHide);
              this.prevHidden = shouldHide;
              this.notifySlider();
            }
          }
          // MSC MOD END

          const e = this.convertTime(s);
          this.render(e);
          if (this.isLoading) this.onLoad(false);
        }
      }
    );
}();
